import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  public userInfo: any = {};

  selectedProperty: any;
  showLogin: boolean = true;
  showDashboard: boolean = false;
  title: string = 'SSK';
  public isAuthenticated: boolean = false;
  public showPasswordText: boolean = false;
  public passwordIcon: string = 'eye-off';

  constructor(public router: Router, private activatedRoute: ActivatedRoute) {
  }

  async ngOnInit() {
  }

  async ngAfterViewInit() {
    await this.authenticate().then(async (x) => {
      if (x) {
        this.getClaims();
        localStorage.setItem('ssk_isAuthenticated', 'true');
        localStorage.setItem('ssk_isLoggedIn', 'true');

        //var isLoggedIn = localStorage.getItem('ssk_isLoggedIn');

        this.showLogin = false;
        this.showDashboard = true;
        this.isAuthenticated = true;

        this.router.navigate(['/dashboard']);

      } else {
        this.router.navigate(['/']);
      }
    });
  }

  async getClaims() {
    const token = localStorage.getItem('ssk_access_token');

    if (token) {
      this.decodeToken(token);
    }
  }

  decodeToken(token: string): any {
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken) {
        console.log('JWT claims:', decodedToken);
      } else {
        console.log('Failed to decode JWT token');
      }
    } catch (error) {
      console.log('Error decoding JWT token:', error);
    }
  }

  redirectToAzure() {

  }

  async authenticate(): Promise<boolean> {
    let isLoggedIn = await this.isLoggedIn();

    if (!isLoggedIn) {
      const url = this.activatedRoute.snapshot.fragment; // get the fragment part of the URL

      console.log('url: ', url);

      if (!url) {
        return false;
      }

      const params = new URLSearchParams(url);
      // http://localhost:4200/auth#error=access_denied&error_description=AADB2C90091:+The+user+has+cancelled+entering+self-asserted+information.%0D%0ACorrelation+ID:+068f44c4-1919-4aaf-ae1f-6c90bdf21b49%0D%0ATimestamp:+2024-05-27+01:45:23Z%0D%0A
      // check for errors
      const error = params.get('error');
      const errorDescription = params.get('error_description');
      // TODO: handle error and errorDescription (do something, log, etc.)

      if (error) {
        return false;
      }

      const token = params.get('access_token');
      const tokenType = params.get('token_type');
      const expiresIn = params.get('expires_in');

      if (!token || tokenType !== 'Bearer' || !expiresIn) {
        return false;
      }

      localStorage.setItem('ssk_access_token', token);
      localStorage.setItem('ssk_token_type', tokenType);
      localStorage.setItem('ssk_expires_in', expiresIn);

      const currentTime = Math.floor(Date.now() / 1000);

      const expirationTime = currentTime + parseInt(expiresIn);

      localStorage.setItem('ssk_expiration_time', expirationTime.toString());
    }

    return true;
  }

  async isLoggedIn(): Promise<boolean> {
    const expirationTime = await localStorage.getItem('ssk_expiration_time');

    if (!expirationTime) {
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);

    return currentTime < parseInt(expirationTime);
  }

}
